import {put} from 'redux-saga/effects';
import {setApply as pipelineSetApply} from 'src/services/pipelines/actions';
import {setApply as builderSetApply} from 'src/services/builder/actions';
import {filterClose, pipelineClose} from './actions';
import {FILTER_OPEN, PIPELINE_OPEN} from './types';

export default (flows) => {
  function* filterOpen() {
    yield put(pipelineSetApply(false));
    yield put(pipelineClose());
  }

  function* pipelineOpen() {
    yield put(builderSetApply(false));
    yield put(filterClose());
  }

  flows.watch(FILTER_OPEN, filterOpen);
  flows.watch(PIPELINE_OPEN, pipelineOpen);

  return flows.getSagas();
};
